import { memo, useMemo, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Badge } from '../ui/badge';
import { getInvestorIndustries } from './helpers';

const InvestorIndustries = memo(function InvestorIndustries({
  industries,
  t,
  baseVisibleCount = 1,
  alwaysShowAll = false,
  className = 'flex flex-wrap gap-2 mb-4',
  toggleClassName = 'inline-flex cursor-pointer items-center gap-1 text-xs text-blue-600 hover:text-blue-800 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded-full',
}) {
  const [open, setOpen] = useState(false);
  const list = useMemo(() => getInvestorIndustries({ industries }), [industries]);

  if (!list.length) {
    return null;
  }

  const visibleCount = alwaysShowAll
    ? list.length
    : list.length <= 2
      ? list.length
      : baseVisibleCount;

  const hasMore = list.length > visibleCount;
  const visible = open || alwaysShowAll ? list : list.slice(0, visibleCount);

  return (
    <div className={className}>
      {visible.map((industry, index) => (
        <Badge key={`${industry}-${index}`} text={industry} variant="v1" />
      ))}
      {hasMore && (
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className={toggleClassName}
          aria-expanded={open}
        >
          {open ? t('investorCard.hideIndustries') : t('investorCard.moreIndustries')}
          {open ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </button>
      )}
    </div>
  );
});

export default InvestorIndustries;
